import React, { type FC } from 'react'

interface IconFlagSwallowtailProps {
  width?: string
  height?: string
}

const IconFlagSwallowtail: FC<IconFlagSwallowtailProps> = ({
  width,
  height,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
    >
      <g clipPath="url(#clip0_1259_3253)">
        <path
          d="M1.6875 0.84375C1.6875 0.376172 1.31133 0 0.84375 0C0.376172 0 0 0.376172 0 0.84375V1.125V2.8125V10.6875V12.375V17.1562C0 17.6238 0.376172 18 0.84375 18C1.31133 18 1.6875 17.6238 1.6875 17.1562V12.375H14.9062C15.3738 12.375 15.75 11.9988 15.75 11.5312C15.75 11.3484 15.6902 11.1727 15.5813 11.025L12.375 6.75L15.5813 2.475C15.6902 2.32734 15.75 2.15156 15.75 1.96875C15.75 1.50117 15.3738 1.125 14.9062 1.125H1.6875V0.84375ZM1.6875 2.8125H13.2188L11.025 5.7375C10.575 6.33867 10.575 7.16133 11.025 7.7625L13.2188 10.6875H1.6875V2.8125Z"
          fill="currentColor"
          shapeRendering="geometricPrecision"
        />
      </g>
      <defs>
        <clipPath id="clip0_1259_3253">
          <rect width="15.75" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconFlagSwallowtail
